import { useEffect, useState } from 'react';

const useReview = () => {
    const [review, setReview] = useState();
    useEffect(() => {
        fetch('https://rocky-fjord-15900.herokuapp.com/reviews')
            .then(res => res.json())
            .then(data => setReview(data))
    }, [])
    return [review]
};

export default useReview;